import React from 'react'

import { Button, Colorway, H1, P } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

const VerifyEmailError = ({ onRedirectToLogin }) => (
  <div className="touchless-email-verification-error">
    <Colorway className="touchless-email-verification-error-colorways">
      <Icon name="dizzybot-error" />
    </Colorway>
    <H1>Link expired</H1>
    <P>
      Hi, there! It looks like you don’t have an account with us yet. For your
      protection, links to verify account information expire within 72 hours.
      Please click below to create your account.
    </P>
    <Button
      className="touchless-email-verification-error-button"
      type="primary"
      onClick={onRedirectToLogin}
    >
      Create account
    </Button>
  </div>
)

export default VerifyEmailError
